import filter from 'lodash/filter';
import find from 'lodash/find';
import forEach from 'lodash/forEach';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import { useEffect } from 'react';

import { useStores } from '../stores';
import { detectBrowser } from '../utilities';
import useConfig from './useConfig';

export default function useFormData(container) {
  const { intentForFormData, intentUserInput, jobSearch } = useConfig();
  const { bot } = useStores();

  useEffect(() => {
    const rootEl = container;
    const divFormEl = rootEl.current.querySelector('.formInput');

    if (divFormEl) {
      const requestParameters = {};
      divFormEl.classList.add('form-container');

      const formMesId = divFormEl.getAttribute('data-mesid');
      const submitBtn = divFormEl.querySelector('input[type=submit]');
      const formFields = divFormEl.querySelectorAll('input, select, textarea');
      let intentMesId = 0;

      submitBtn.onclick = e => {
        if (detectBrowser.isIE) {
          e.preventDefault();
        }
        divFormEl.querySelectorAll('.formInput input').forEach(event => event.reportValidity());

        let validation = true;
        divFormEl.querySelectorAll('.formInput input').forEach(event => {
          if (!event.checkValidity()) validation = false;
        });

        if (validation) {
          const filteredFields = filter(formFields, field => field && field.type !== 'submit');
          forEach(filteredFields, item => {
            if (item.type === 'checkbox') {
              requestParameters[item.name] = item.checked;
              return requestParameters;
            }
            if (item.type === 'radio') {
              if (item.checked) {
                requestParameters[item.name] = item.value;
                return requestParameters;
              }
              return null;
            }
            if (item.value) {
              requestParameters[item.name] = item.value;
              return requestParameters;
            }
            return null;
          });

          /**
           * get an intent (mesId) for the `processSendForm` request,
           * if intentForFormData exists in the config
           * (This feature is for a form with select/checkbox/radio-buttons)
           */
          if (intentForFormData?.enabled && intentForFormData.formSelection.length) {
            const fieldKeys = Object.keys(requestParameters);
            let selectedKey = '';

            // find the config object with current inputName (The first object will be chosen)
            const intentObject = find(intentForFormData.formSelection, item => {
              const selectedIntent = includes(fieldKeys, item.inputName);
              if (selectedIntent) {
                selectedKey = item.inputName;
              }
              return includes(fieldKeys, item.inputName);
            });

            // if intentObject is not empty - find the intent MesId
            if (!isEmpty(intentObject) && intentObject.values.length) {
              const selectedIntent = find(intentObject.values, value => {
                const fieldValue = requestParameters[selectedKey].toString();
                const comparisonResult = value.selectionValue.localeCompare(fieldValue);
                if (comparisonResult === 0) {
                  return true;
                }
                return false;
              });
              intentMesId = !isEmpty(selectedIntent) ? selectedIntent.displayIntent : 0;
            }
          }

          const question = submitBtn.value;
          const mesId = intentMesId || formMesId;

          bot.formFields.input_name = requestParameters.input_name || bot.formFields.input_name;

          if (intentUserInput?.enabled) {
            const fieldKeys = Object.keys(requestParameters);
            forEach(intentUserInput.userSelection, item => {
              const isKey = includes(fieldKeys, item.inputName);
              if (isKey) {
                bot.formFields[item.inputName] = requestParameters[item.inputName];
              }
            });
          }

          if (jobSearch?.enabled) {
            const fieldKeys = Object.keys(requestParameters);
            forEach(fieldKeys, item => {
              bot.formFields[item] = requestParameters[item] || bot.formFields[item];
            });
          }

          // need to cut '_NUMBERS' from an end of the input name
          const changedRequestParameters = Object.entries(requestParameters).map(parameter => {
            const replasedText = parameter[0].replace(/(_\d+)$/, '');
            parameter[0] = replasedText;
            return parameter;
          });
          const newRequestParameters = Object.fromEntries(changedRequestParameters);

          bot.processSendForm(newRequestParameters, Number(mesId), question);

          forEach(formFields, field => {
            field.disabled = true;
          });
        }
      };
    }
  }, [bot, container, intentForFormData, intentUserInput, jobSearch]);
}
